var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 400c-79.402 0-144-64.598-144-144s64.598-144 144-144 144 64.598 144 144-64.598 144-144 144zm0-256c-61.757 0-112 50.243-112 112s50.243 112 112 112 112-50.243 112-112-50.243-112-112-112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 80c-8.837 0-16-7.164-16-16v-48c0-8.836 7.163-16 16-16s16 7.164 16 16v48c0 8.836-7.163 16-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 512c-8.837 0-16-7.164-16-16v-48c0-8.836 7.163-16 16-16s16 7.164 16 16v48c0 8.836-7.163 16-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 272h-48c-8.837 0-16-7.164-16-16s7.163-16 16-16h48c8.837 0 16 7.164 16 16s-7.163 16-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 272h-48c-8.837 0-16-7.164-16-16s7.163-16 16-16h48c8.837 0 16 7.164 16 16s-7.163 16-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.765 136.235c-14.126 0-21.422-17.206-11.313-27.314l33.941-33.941c6.249-6.248 16.38-6.249 22.627 0 6.249 6.248 6.249 16.379 0 22.627l-33.941 33.941c-3.125 3.125-7.22 4.687-11.314 4.687z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.294 441.706c-14.126 0-21.422-17.206-11.313-27.314l33.941-33.941c6.25-6.248 16.381-6.248 22.627 0 6.249 6.248 6.249 16.379 0 22.627l-33.942 33.942c-3.124 3.123-7.218 4.686-11.313 4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.706 441.706c-4.095 0-8.189-1.562-11.313-4.686l-33.941-33.941c-6.249-6.249-6.249-16.379 0-22.627 6.248-6.249 16.379-6.249 22.627 0l33.941 33.941c10.108 10.106 2.812 27.313-11.314 27.313z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.235 136.235c-4.095 0-8.189-1.562-11.313-4.686l-33.942-33.941c-6.249-6.249-6.249-16.379 0-22.627 6.248-6.249 16.379-6.249 22.627 0l33.941 33.941c10.109 10.107 2.813 27.313-11.313 27.313z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.0a1e5df9.svg";
export { ForwardRef as ReactComponent };